var map = {
	"./burgerBuilder1.png": "0958",
	"./burgerBuilder2.png": "032d",
	"./burgerBuilder3.png": "cf76",
	"./forBarna1.png": "431f",
	"./forBarna2.png": "ac99",
	"./forBarna3.png": "77fa",
	"./myBoard1.png": "9632",
	"./portfolio1.png": "439b",
	"./portfolio2.png": "ca59",
	"./portfolio3.png": "d726",
	"./retro1.png": "ca76",
	"./retro2.png": "59ee",
	"./retro3.png": "b342"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4d25";